import React from "react";
import { Redirect, useParams } from "react-router-dom";

const RedirectToFamilyId = () => {
  const { familyId } = useParams();

  return <Redirect to={`/${familyId}`} />;
};
export default RedirectToFamilyId;
